(() => {
  if (window.SpaceArmorySizingAttribution) return;
  const methodKey = 'properties[_Size Selection Method]';
  const guidesKey = 'properties[_Sizing Guides Viewed]';
  const memory = new Map();
  const sizeName = /^(size|fit|beden|size fit)$/i;

  function context(form) {
    const info = form?.closest('product-info');
    if (!info) return null;
    const scanner = info.querySelector('face-fit-scanner');
    const id = scanner?.dataset.productId || info.dataset.productId;
    let names = [];
    try { names = JSON.parse(scanner?.dataset.productOptions || '[]'); } catch {}
    const sized = names.some(name => sizeName.test(String(name).trim())) ||
      [...info.querySelectorAll('variant-selects .product-form__input')].some(group => {
        const control = group.querySelector('[data-option-name], select, input');
        const name = group.dataset.optionName || control?.dataset.optionName ||
          control?.name?.match(/^options\[(.+)\]$/)?.[1] || group.querySelector('legend')?.firstChild?.textContent || '';
        return sizeName.test(name.trim());
      });
    return sized ? {info, id} : null;
  }

  function readGuides(id) {
    if (!id) return {};
    let value = memory.get(id) || {};
    try {
      const saved = JSON.parse(sessionStorage.getItem('sa_sizing_guides_v1:' + id));
      if (saved) value = {camera: saved.camera === true, manual: saved.manual === true};
    } catch {}
    return value;
  }

  document.addEventListener('space-armory:sizing-guide-opened', event => {
    const guide = event.detail?.guide;
    if (!['camera', 'manual'].includes(guide)) return;
    const info = event.target.closest?.('product-info');
    const id = info?.querySelector('face-fit-scanner')?.dataset.productId || info?.dataset.productId;
    if (!id) return;
    const value = {...readGuides(id), [guide]: true};
    memory.set(id, value);
    try { sessionStorage.setItem('sa_sizing_guides_v1:' + id, JSON.stringify(value)); } catch {}
  });

  function decorateForm(data, form) {
    // These describe this addition, never inherited fields from an earlier add.
    data.delete(methodKey);
    data.delete(guidesKey);
    const current = context(form);
    const rules = window.SpaceArmoryFitRules;
    if (!current) {
      (rules?.scanStatsKeys || []).forEach(key => data.delete(`properties[${key}]`));
      return;
    }
    const seen = readGuides(current.id);
    const viewed = [seen.camera && 'Camera measurement window', seen.manual && 'Manual guide'].filter(Boolean);
    const source = data.get('properties[_Face Fit Source]') || '';
    const measurement = data.get('properties[Measured Size]') || data.get('properties[_Face Fit Measurement]');
    if (!measurement) {
      // A failed/cancelled scan followed by manual buying still carries its
      // actual session counters; never pretend it produced a measurement.
      (rules?.scanStatsKeys || []).forEach(key => data.delete(`properties[${key}]`));
      const key = 'sa_face_fit_attempts_v1:' + current.id;
      let stats = window.SpaceArmoryFitAttemptSessions?.get(key);
      if (!stats) try { stats = JSON.parse(sessionStorage.getItem(key)); } catch {}
      Object.entries(rules?.scanStatsProperties?.(stats, false) || {}).forEach(([name,value]) => data.set(`properties[${name}]`, value));
    }
    const purchase = current.info.faceFitPurchase;
    const freshSavedResult = purchase?.freshMeasurement && purchase?.savedMeasurement &&
      purchase.freshMeasurement.cm === purchase.savedMeasurement.cm &&
      purchase.freshMeasurement.measuredAt === purchase.savedMeasurement.measuredAt;
    let method;
    if (measurement && source.startsWith('saved_profile |') && !freshSavedResult) method = 'Saved measurement';
    else if (measurement && (/^(auto_result|applied) \| /.test(source) || (source.startsWith('saved_profile |') && freshSavedResult))) {
      method = 'Camera measurement';
      const measuredSize = String(measurement).match(/-\s*(S|M|L|XL|XXL)\s*$/)?.[1];
      const selectedSize = purchase?.resolve()?.options?.[purchase.sizeIndex];
      const aliases = {S:['s','small'],M:['m','medium'],L:['l','large'],XL:['xl','x-large','extra large'],XXL:['xxl','2xl','xx-large','extra extra large']};
      if (measuredSize && selectedSize && !aliases[measuredSize].includes(selectedSize.trim().toLowerCase())) {
        method = 'Manual size selection after camera measurement';
      }
    } else if (measurement) method = 'Measurement attached (source unavailable)';
    else if (seen.manual) method = 'Manual guide viewed';
    else if (seen.camera) method = 'Camera window opened without completed measurement';
    else method = 'Direct size selection';
    data.set(methodKey, method);
    if (viewed.length) data.set(guidesKey, viewed.join(' + '));
  }

  window.SpaceArmorySizingAttribution = {decorateForm};
})();
